import { apiRequests } from "../services/api";
import { GET_PARTNER_COMPANIES, GET_PARTNER_COMPANY_BY_ID, GET_PARTNERS } from "../graphql/query/partner/query";
import { CREATE_PARTNER, CREATE_PARTNER_COMPANY, UPDATE_PARTNER_COMPANY, DELETE_PARTNER_COMPANY } from "../graphql/mutations/partner/mutations";

/** Obtener empresas partner activas */
export const getPartnerCompanies = async (activeOnly = true) => {
  try {
    const response = await apiRequests(GET_PARTNER_COMPANIES, { activeOnly });
    const data = response?.data?.getPartnerCompanies || response?.getPartnerCompanies;
    return data?.partnerCompanies || [];
  } catch (error) {
    console.error("Error al obtener empresas partner:", error);
    return [];
  }
};

/** Obtener técnicos partner (todos o filtrados por empresa) */
export const getPartners = async (partnerCompanyId = null) => {
  try {
    const variables = partnerCompanyId ? { partnerCompanyId } : {};
    const response = await apiRequests(GET_PARTNERS, variables);
    const data = response?.data?.getPartners || response?.getPartners;
    return data?.partners || [];
  } catch (error) {
    console.error("Error al obtener partners:", error);
    return [];
  }
};

/** Obtener empresa partner por ID */
export const getPartnerCompanyById = async (id) => {
  try {
    const response = await apiRequests(GET_PARTNER_COMPANY_BY_ID, { id });
    const data = response?.data?.getPartnerCompanyById || response?.getPartnerCompanyById;
    return data?.partnerCompany || null;
  } catch (error) {
    console.error("Error al obtener empresa partner:", error);
    return null;
  }
};

/** Crear empresa partner */
export const createPartnerCompany = async (partnerCompanyRequest) => {
  try {
    const response = await apiRequests(CREATE_PARTNER_COMPANY, { partnerCompanyRequest });
    const result = response?.data?.createPartnerCompany || response?.createPartnerCompany;
    return result;
  } catch (error) {
    console.error("Error al crear empresa partner:", error);
    throw error;
  }
};

/** Actualizar empresa partner */
export const updatePartnerCompany = async (id, partnerCompanyRequest) => {
  try {
    const response = await apiRequests(UPDATE_PARTNER_COMPANY, { id, partnerCompanyRequest });
    const result = response?.data?.updatePartnerCompany || response?.updatePartnerCompany;
    return result;
  } catch (error) {
    console.error("Error al actualizar empresa partner:", error);
    throw error;
  }
};

/** Desactivar empresa partner (solo cambia estado, no elimina) */
export const deletePartnerCompany = async (id) => {
  try {
    const response = await apiRequests(DELETE_PARTNER_COMPANY, { id });
    const result = response?.data?.deletePartnerCompany || response?.deletePartnerCompany;
    return result;
  } catch (error) {
    console.error("Error al desactivar empresa partner:", error);
    throw error;
  }
};

/** Crear técnico partner (manual o desde carga masiva sin archivos) */
export const createPartner = async (partnerRequest, files = {}) => {
  try {
    const variables = {
      partnerRequest,
      frontIdCard: files.frontIdCard || null,
      backIdCard: files.backIdCard || null,
      photo: files.photo || null,
    };
    const response = await apiRequests(CREATE_PARTNER, variables);
    const errors = response?.errors;
    if (errors?.length) {
      const err = new Error(errors.map((e) => e.message).join(" "));
      err.response = { data: { errors } };
      throw err;
    }
    const result = response?.data?.createPartner || response?.createPartner;
    return result;
  } catch (error) {
    console.error("Error al crear partner:", error);
    throw error;
  }
};
